import styled from "styled-components";
import {  useEffect } from "react";
import Modal from "react-modal";

const customStyles = {
  overlay: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0",
    padding: "0",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: "999",
  },
  content: {
    background: "linear-gradient(120deg, rgba(30,34,45,0.92) 60%, rgba(60,80,120,0.85) 100%)",
    borderRadius: "18px",
    boxShadow: "0 4px 32px 0 rgba(0,0,0,0.45), 0 0 0 1.5px #5fa8e6",
    border: "1.5px solid #5fa8e6",
    backdropFilter: "blur(14px)",
    WebkitBackdropFilter: "blur(14px)",
    color: "#fff",
    width: "fit-content",
    height: "fit-content",
    position: "absolute",
    zIndex: "999",
    overflowY: "auto",
    overflowX: "hidden",
    maxHeight: "90%",
    maxWidth: "95%",
    display: "flex",
    flexDirection: "column",
    minHeight: "420px",
  },
};

const ReactModal = ({ modalOpen, component, closeModal }) => {
  // this may cause performance issues
  useEffect(() => {
    if (modalOpen) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [modalOpen]);

  return (
    <>
      <Modal
        isOpen={modalOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        className="react-modal"
        appElement={document.getElementById('root')}
      >
        <Button onClick={closeModal} className="btn btn-dark">
          X
        </Button>
        {component}
      </Modal>
    </>
  );
};
export default ReactModal;

const Button = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 100;
  font-weight: 800;
  border: 1px gray solid;
`;
